import { emitMortgageClickGa4 } from '@/common/utilities/nojq/_load.ojolink.js';
import { resolveClickCta } from '@/common/utilities/nojq/_utilities.js';
export default {
    name: 'mvtCardMortgageNew',
    props: ['data', 'state', 'provider', 'openMortgage'],
    inject: ['$eventBus'],
    computed:{
        utmSource(){
            return this.provider && this.provider.toLowerCase().indexOf('bankrate') > -1 ? `&utm_source=movoto` : '';
        }
    },
    methods: {
        applyBtn(cpc, evt) {
            emitMortgageClickGa4({ label: 'Lower', linkName: resolveClickCta('APR', evt, ''), category: 'buy' });
            if (this.provider) {
                this.$eventBus.$emit('ga', { el: this.provider + ' Click', props: { link_name: 'Next' } });
            }
        },
    },
};
